interface CoachDefaultAvailability {
  totalInMinute: Possible<number>;
}
export const isCoachAvailabilityOnboarded = (
  defaultAvailability: Possible<CoachDefaultAvailability>,
): boolean => (defaultAvailability?.totalInMinute ?? 0) >= 5 * 60;
